module.exports = __webpack_public_path__ + "assets/config_loop.ad73b4cb.svg";